export enum ResultCode {
  AUTHORISED = <any>'AUTHORISED',
  REFUSED = <any>'REFUSED',
  ERROR = <any>'ERROR',
  CANCELLED = <any>'CANCELLED',
  RECEIVED = <any>'RECEIVED',
  REDIRECTSHOPPER = <any>'REDIRECTSHOPPER',
  PENDING = <any>'PENDING', /*iDEAL*/
}

export namespace ResultCode {
  export function fromValue(value: string): ResultCode {
    return ResultCode[value.toUpperCase()];
  }
}